import Icon from '../components/Icon'

Icon.register({
  caravan: {
    width: 640,
    height: 512,
    paths: [
      {
        d: 'M416 208c8.8 0 16 7.2 16 16s-7.2 16-16 16-16-7.2-16-16 7.2-16 16-16zM624 320c8.8 0 16 7.2 16 16v32c0 8.8-7.2 16-16 16h-336c0 53-43 96-96 96s-96-43-96-96h-32c-35.3 0-64-28.7-64-64v-256c0-35.3 28.7-64 64-64h352c88.3 0 160 71.7 160 160v160h48zM192 432c26.5 0 48-21.5 48-48 0-26.5-21.5-48-48-48s-48 21.5-48 48 21.5 48 48 48zM256 192v-64c0-17.7-14.3-32-32-32h-128c-17.7 0-32 14.3-32 32v64c0 17.7 14.3 32 32 32h128c17.7 0 32-14.3 32-32zM448 320v-192c0-17.7-14.3-32-32-32h-64c-17.7 0-32 14.3-32 32v192h128z'
      }
    ]
  }
})
